import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SaveIcon } from 'lucide-react';
export function NotificheTab() {
  const [notifications, setNotifications] = useState({
    accessoPiattaforma: {
      email: true,
      interno: true
    },
    inserimentoPiano: {
      email: true,
      interno: true
    },
    accettazionePiano: {
      email: true,
      interno: true
    },
    scadenzaPiano: {
      email: true,
      interno: true
    },
    invioEmail: {
      email: false,
      interno: true
    },
    invioPec: {
      email: true,
      interno: true
    },
    fatturaPagata: {
      email: true,
      interno: true
    },
    nuovaFattura: {
      email: false,
      interno: true
    },
    nuovoCliente: {
      email: false,
      interno: true
    },
    nuovoPagamento: {
      email: true,
      interno: true
    },
    sollecitoPagamento: {
      email: true,
      interno: true
    },
    erroreImportazione: {
      email: true,
      interno: true
    }
  });
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>, notificationType: string, channel: 'email' | 'interno') => {
    setNotifications({
      ...notifications,
      [notificationType]: {
        ...notifications[notificationType],
        [channel]: event.target.checked
      }
    });
  };
  const handleSaveNotifications = () => {
    // Logica per salvare le notifiche
    alert('Configurazione notifiche salvata con successo');
  };
  return <Card data-id="element-1383">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1384">
        Configurazione Notifiche
      </h3>
      <div className="space-y-6" data-id="element-1385">
        <p className="text-sm text-gray-500" data-id="element-1386">
          Seleziona per quali eventi desideri ricevere notifiche e attraverso
          quali canali.
        </p>
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg" data-id="element-1387">
          <table className="min-w-full divide-y divide-gray-300" data-id="element-1388">
            <thead className="bg-gray-50" data-id="element-1389">
              <tr data-id="element-1390">
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" data-id="element-1391">
                  Evento
                </th>
                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900" data-id="element-1392">
                  Email
                </th>
                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900" data-id="element-1393">
                  Notifica Interna
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white" data-id="element-1394">
              <tr data-id="element-1395">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1396">
                  Accesso alla piattaforma
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1397">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.accessoPiattaforma.email} onChange={e => handleToggle(e, 'accessoPiattaforma', 'email')} data-id="element-1398" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1399">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.accessoPiattaforma.interno} onChange={e => handleToggle(e, 'accessoPiattaforma', 'interno')} data-id="element-1400" />
                </td>
              </tr>
              <tr data-id="element-1401">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1402">
                  Inserimento piano di rientro
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1403">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.inserimentoPiano.email} onChange={e => handleToggle(e, 'inserimentoPiano', 'email')} data-id="element-1404" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1405">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.inserimentoPiano.interno} onChange={e => handleToggle(e, 'inserimentoPiano', 'interno')} data-id="element-1406" />
                </td>
              </tr>
              <tr data-id="element-1407">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1408">
                  Accettazione piano di rientro
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1409">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.accettazionePiano.email} onChange={e => handleToggle(e, 'accettazionePiano', 'email')} data-id="element-1410" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1411">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.accettazionePiano.interno} onChange={e => handleToggle(e, 'accettazionePiano', 'interno')} data-id="element-1412" />
                </td>
              </tr>
              <tr data-id="element-1413">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1414">
                  Scadenza piano di rientro
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1415">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.scadenzaPiano.email} onChange={e => handleToggle(e, 'scadenzaPiano', 'email')} data-id="element-1416" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1417">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.scadenzaPiano.interno} onChange={e => handleToggle(e, 'scadenzaPiano', 'interno')} data-id="element-1418" />
                </td>
              </tr>
              <tr data-id="element-1419">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1420">
                  Invio email
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1421">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.invioEmail.email} onChange={e => handleToggle(e, 'invioEmail', 'email')} data-id="element-1422" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1423">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.invioEmail.interno} onChange={e => handleToggle(e, 'invioEmail', 'interno')} data-id="element-1424" />
                </td>
              </tr>
              <tr data-id="element-1425">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1426">
                  Invio PEC
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1427">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.invioPec.email} onChange={e => handleToggle(e, 'invioPec', 'email')} data-id="element-1428" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1429">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.invioPec.interno} onChange={e => handleToggle(e, 'invioPec', 'interno')} data-id="element-1430" />
                </td>
              </tr>
              <tr data-id="element-1431">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1432">
                  Fattura pagata
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1433">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.fatturaPagata.email} onChange={e => handleToggle(e, 'fatturaPagata', 'email')} data-id="element-1434" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1435">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.fatturaPagata.interno} onChange={e => handleToggle(e, 'fatturaPagata', 'interno')} data-id="element-1436" />
                </td>
              </tr>
              <tr data-id="element-1437">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1438">
                  Nuova fattura
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1439">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.nuovaFattura.email} onChange={e => handleToggle(e, 'nuovaFattura', 'email')} data-id="element-1440" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1441">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.nuovaFattura.interno} onChange={e => handleToggle(e, 'nuovaFattura', 'interno')} data-id="element-1442" />
                </td>
              </tr>
              <tr data-id="element-1443">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1444">
                  Nuovo cliente
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1445">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.nuovoCliente.email} onChange={e => handleToggle(e, 'nuovoCliente', 'email')} data-id="element-1446" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1447">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.nuovoCliente.interno} onChange={e => handleToggle(e, 'nuovoCliente', 'interno')} data-id="element-1448" />
                </td>
              </tr>
              <tr data-id="element-1449">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1450">
                  Nuovo pagamento
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1451">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.nuovoPagamento.email} onChange={e => handleToggle(e, 'nuovoPagamento', 'email')} data-id="element-1452" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1453">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.nuovoPagamento.interno} onChange={e => handleToggle(e, 'nuovoPagamento', 'interno')} data-id="element-1454" />
                </td>
              </tr>
              <tr data-id="element-1455">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1456">
                  Sollecito pagamento
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1457">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.sollecitoPagamento.email} onChange={e => handleToggle(e, 'sollecitoPagamento', 'email')} data-id="element-1458" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1459">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.sollecitoPagamento.interno} onChange={e => handleToggle(e, 'sollecitoPagamento', 'interno')} data-id="element-1460" />
                </td>
              </tr>
              <tr data-id="element-1461">
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-1462">
                  Errore importazione
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1463">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.erroreImportazione.email} onChange={e => handleToggle(e, 'erroreImportazione', 'email')} data-id="element-1464" />
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center" data-id="element-1465">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={notifications.erroreImportazione.interno} onChange={e => handleToggle(e, 'erroreImportazione', 'interno')} data-id="element-1466" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="flex justify-end" data-id="element-1467">
          <Button type="button" onClick={handleSaveNotifications} icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-1469" />} data-id="element-1468">
            Salva Configurazione
          </Button>
        </div>
      </div>
    </Card>;
}